module.exports = __webpack_public_path__ + "static/media/v2.83aa3401.svg";